import { getDownload } from "./Api";

export async function goToDownload(awardId, entryId, mediaId) {
    const resp = await getDownload(awardId, entryId, mediaId);
    console.log("goToDownload resp", resp); 
    
    if(resp.response.statusText.toUpperCase() !== "OK" || resp.data.status !== "OK") {
        //TODO: show error
    }
    else {
        window.location.href = resp.data.url;
    }
}